import { useEffect, useRef } from 'react';
import { useWatch, type UseFormReturn } from 'react-hook-form';

import type { FormValues, SubmitValues } from './schema.ts';

const REGIONAL_GERMAN_FIELDS = ['valueDeAt', 'valueDeDe'] as const;

/**
 * Keeps DE-AT and DE-DE equal to DE-CH while they are empty or still hold its previous text. The regional texts start as
 * copies of DE-CH, so an edit or a generation of DE-CH is theirs too until they get a text of their own.
 */
export const useRegionalGermanSync = ({ control, getValues, setValue }: UseFormReturn<FormValues, unknown, SubmitValues>) => {
  const valueDe = useWatch({ control, name: 'valueDe' });
  const previousValueDe = useRef(valueDe);

  useEffect(() => {
    REGIONAL_GERMAN_FIELDS.forEach((fieldName) => {
      const regionalValue = getValues(fieldName);
      if (!regionalValue || regionalValue === previousValueDe.current) {
        setValue(fieldName, valueDe);
      }
    });
    previousValueDe.current = valueDe;
  }, [valueDe, getValues, setValue]);
};
